// eslint-disable-next-line canonical/filename-match-regex
export const isSSR = typeof window === 'undefined';
export const requiresSafariHack = !isSSR && navigator?.userAgent?.includes('Version/');
export const supportsHiddenUntilFound = !isSSR && 'onbeforematch' in document.body;
